export default __webpack_public_path__ + "static/media/privacypolicy.7670ac12.svg";